import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateBlockValue } from 'i18n';
import {
    BudgetProposalT,
    BudgetVentilatedDataWithCadrageT,
} from 'routes/BudgetModule/config/types';
import 'routes/BudgetModule/components/BudgetProposal/shared/Grids/_commonGrid.scss';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import Grid from './components/Grid';

type Props = {
    budgetProposal: BudgetProposalT;
    ventilatedData: BudgetVentilatedDataWithCadrageT[];
    inscriptionsData: {
        data: InscriptionT[];
        columns: ResponseColumnT[];
    };
};

const BudgetVentilatedByResource: React.FC<Props> = ({
    budgetProposal,
    ventilatedData,
    inscriptionsData,
}) => {
    const { t } = useTranslation();
    const { by } = budgetProposal;

    const gridTitle = t('budgetProposal.requestTableTitle', {
        ventilationBy: translateBlockValue(by, true),
    });

    return (
        <div className="grid-wrapper left" style={{ height: 'auto' }}>
            <Grid
                data={ventilatedData}
                budgetProposal={budgetProposal}
                gridTitle={gridTitle}
                inscriptionsData={inscriptionsData}
                ventilationBy="resource"
                hideCanEditColumn={false}
            />
        </div>
    );
};

export default BudgetVentilatedByResource;
